import dayjs from 'dayjs';

import { DATE } from '@cast/constants';
import {
  Icons,
  Typography,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

type Props = {
  acknowledgedAt?: string;
};

export const OpsPilotEnabledNotice = ({ acknowledgedAt }: Props) => {
  if (!acknowledgedAt) {
    return null;
  }

  return (
    <Stack
      direction="row"
      gap={6}
      alignItems="center"
      data-testid="opspilot-acknowledged-notice"
      sx={{ color: colorOrToken('green.500', tokens.theme.fg.status.success) }}
    >
      <Icons.CheckCircle size={16} weight="fill" />
      <Typography variant="P12R" color={tokens.theme.fg.structural.secondary}>
        Enabled and usage guidelines acknowledged on{' '}
        {dayjs(acknowledgedAt).format(DATE)}
      </Typography>
    </Stack>
  );
};
